import React, { useEffect } from 'react'
import InnerHTML from 'dangerously-set-html-content'
import IntersectionVisible from 'components/IntersectionVisible'
import analytics from 'global/AnalyticsData'

const CustomHtmlStep = ({
  brk,
  breakId,
  step,
  onEngage = function () {},
  onAwardPoints = function () {},
  userType,
  service,
  nextStepButton,
}) => {
  useEffect(() => {
    const handleCustomEvent = event => {
      const { action, data } = event.detail

      analytics.stepEvent(`step_interaction_custom_html_${action}`, step, {
        context_id: step.id,
        context: action,
        result: data,
      })
    }

    window.addEventListener('CUSTOM_HTML_EVENT', handleCustomEvent)

    // Cleanup the listener when the component unmounts
    return () => {
      window.removeEventListener('CUSTOM_HTML_EVENT', handleCustomEvent)
    }
  }, [step])

  const handleIsOnScreen = isIntersecting => {
    if (isIntersecting) {
      onEngage()
      onAwardPoints()
    }
  }

  // Would be nice if we could wrap rules in a SCSS selector like `.step-${step.id} { ... }` to isloate them
  const inlineStyle = `
		${step.customCss}
	`

  return (
    <section className={`custom-html-step`}>
      <div
        className={`step-content with-shadow ${
          brk?.navigationType === 'TOP' ? 'top-navigation' : ''
        }`}
      >
        <IntersectionVisible
          active={true}
          options={{
            threshold: 0.4,
          }}
          onIntersect={handleIsOnScreen}
        >
          <style
            dangerouslySetInnerHTML={{
              __html: inlineStyle,
            }}
          />
          <InnerHTML html={step.customHtml} />
        </IntersectionVisible>
        {nextStepButton}
      </div>
    </section>
  )
}

export default CustomHtmlStep
